<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <h3 class="card-title">会員情報</h3>
          </CCardHeader>
          <CCardBody>
            <transition name="fade">
              <CAlert color="success" v-show="newMember" transition="expand"
                >新規会員登録に成功しました。</CAlert
              >
            </transition>
            <CForm class="member-info edit-form">
              <CRow>
                <CCol class="px-0 pb-3">
                  <h4 class="sub-title mr-5">登録情報</h4>
                  <CBadge v-if="loadData" :color="(itemToEdit.status == 0) ? 'danger' : 'success' " class="py-2 px-3 mx-2">{{itemToEdit.status | MemberStatus }}</CBadge>
                  <CBadge v-if="loadData" :color="!itemToEdit.keycloakEnabled ? 'danger' : 'success' " class="py-2 px-3 mx-2">{{itemToEdit.keycloakEnabled ? 'ログインできる' : 'ログインできない'}}</CBadge>
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <CInput
                    label="ユーザー名"
                    horizontal
                    plaintext
                    required
                    v-model="itemToEdit.name"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <CInput
                    label="会員カードID"
                    horizontal
                    plaintext
                    required
                    v-model="itemToEdit.cardId"
                  />
                </CCol>
                <CCol lg="6">
                  <CButton @click="onCardIdEditClick()" color="success">
                    <i class="icon cil-pencil"></i> 会員カード発行
                  </CButton>
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.familyName.$dirty &&
                      !$v.itemToEdit.familyName.required
                    "
                  >
                    氏の入力は必須です
                  </div>
                  <div class="required-mark form-group form-row">
                    <label class="col-form-label col-sm-3">氏</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        class="form-control"
                        v-model="itemToEdit.familyName"
                        v-on:input="familyName_furigana"
                      />
                    </div>
                  </div>
                </CCol>
                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.givenName.$dirty &&
                      !$v.itemToEdit.givenName.required
                    "
                  >
                    名の入力は必須です
                  </div>
                  <div class="required-mark form-group form-row">
                    <label class="col-form-label col-sm-3">名</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        class="form-control"
                        v-model="itemToEdit.givenName"
                        v-on:input="givenName_furigana"
                      />
                    </div>
                  </div>
                  <!-- <div
                    class="text-danger input-info"
                    v-if="!$v.itemToEdit.givenName.required"
                  >
                    名の入力は必須です
                  </div>
                  <CInput
                    label="名"
                    class="required-mark"
                    horizontal
                    required
                    v-model="itemToEdit.givenName"
                  /> -->
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <!-- <div
                    class="text-danger input-info"
                    v-if="!$v.itemToEdit.lastName.required"
                  >
                    氏（カナ）の入力は必須です
                  </div>
                  <CInput
                    label="氏（カナ）"
                    class="required-mark"
                    horizontal
                    required
                    v-model="itemToEdit.lastName"
                  /> -->
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.firstName.$dirty &&
                      !$v.itemToEdit.firstName.required
                    "
                  >
                    氏（カナ）の入力は必須です
                  </div>
                  <CInput
                    label="氏（カナ）"
                    class="required-mark"
                    horizontal
                    v-model="itemToEdit.firstName"
                  />
                </CCol>
                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.lastName.$dirty &&
                      !$v.itemToEdit.lastName.required
                    "
                  >
                    名（カナ）の入力は必須です
                  </div>
                  <CInput
                    label="名（カナ）"
                    class="required-mark"
                    horizontal
                    v-model="itemToEdit.lastName"
                  />
                  <!-- <div
                    class="text-danger input-info"
                    v-if="!$v.itemToEdit.firstName.required"
                  >
                    名（カナ）の入力は必須です
                  </div>
                  <CInput
                    label="名（カナ）"
                    class="required-mark"
                    horizontal
                    required
                    v-model="itemToEdit.firstName"
                  /> -->
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <CInput
                    label="生年月日"
                    type="date"
                    horizontal
                    required
                    v-model="itemToEdit.birth"
                  />
                </CCol>
                <CCol lg="6">
                  <CSelect
                    label="性別"
                    horizontal
                    :options="options.genderOptions"
                    :value.sync="itemToEdit.gender"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <CSelect
                    label="ロール"
                    horizontal
                    :options="userGroupsOptions"
                    :value.sync="userGroupName"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol class="px-0 py-3">
                  <h4 class="sub-title">連絡情報</h4>
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <CInput
                    v-if="Gemail"
                    label="Eメールアドレス"
                    horizontal
                    plaintext
                    v-model="itemToEdit.email"
                  />
                  <!-- <p>get: {{addEmail}}</p> -->

                  <div v-else class="form-group form-row">
                    <label class="col-form-label col-sm-3"
                      >Eメールアドレス</label
                    >
                    <div class="col-sm-9">
                      <CButton color="success" @click="addEmailModal = true"
                        >追加</CButton
                      >

                      <CModal
                        color="dark"
                        :closeOnBackdrop="false"
                        :centered="true"
                        :show.sync="addEmailModal"
                      >
                        <template #header>
                          <h4>Eメールアドレス追加</h4>
                        </template>
                        <p>会員のメールアドレスを追加してください。</p>
                        <CInput
                          class="ml-1 mb-3"
                          label="Eメール"
                          horizontal
                          required
                          v-model="addEmail"
                        />
                        <CAlert color="info"
                          >この後は会員にメール認証メールとパスワード更新メールを送信します。会員はメールに従って操作してから、ログインできる会員にアップグレードします。</CAlert
                        >
                        <template #footer class="display-block">
                          <CButton
                            class="float-left"
                            @click="addEmailModal = false"
                            color="danger"
                            ><i class="icon cil-x"></i>キャンセル</CButton
                          >
                          <CButton
                            class="float-right"
                            @click="saveEmail()"
                            color="success"
                            :disabled="$v.addEmail.$invalid"
                            ><i class="icon cil-save"></i> 保存</CButton
                          >
                        </template>
                      </CModal>
                    </div>
                  </div>

                  <!-- <p>Email: {{ itemToEdit.email }}</p>
                  <p v-if="(itemToEdit.email = true)">
                    <CButton color="success">追加</CButton>
                    Have email
                  </p>
                  <p v-else>No email</p> -->
                </CCol>
                <CCol lg="6">
                  <CInput
                    label="承認状態"
                    horizontal
                    plaintext
                    :placeholder="
                      itemToEdit.emailVerified ? '承認済み' : '未承認'
                    "
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <CSelect
                    label="国番号"
                    horizontal
                    :options="codeOptions"
                    :value.sync="itemToEdit.countryCode"
                  />
                </CCol>
                <CCol lg="6">
                  <CInput
                    label="電話番号"
                    horizontal
                    required
                    v-model="itemToEdit.mobile"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol class="px-0 py-3">
                  <h4 class="sub-title">住所</h4>
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <CSelect
                    label="国"
                    horizontal
                    :options="countryOptions"
                    :value.sync="itemToEdit.address.country.id"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <CInput
                    label="郵便番号"
                    horizontal
                    required
                    v-model="itemToEdit.address.zipCode"
                  />
                </CCol>
                <CCol lg="4">
                  <CButton color="success" @click="onInputAddressClick()"
                    ><i class="icon cil-location-pin"></i> 住所自動入力</CButton
                  >
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <CInput
                    label="都道府県"
                    horizontal
                    required
                    v-model="itemToEdit.address.state"
                  />
                </CCol>
                <CCol lg="6">
                  <CInput
                    label="市区町村"
                    horizontal
                    required
                    v-model="itemToEdit.address.city"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <CInput
                    label="地番番地"
                    horizontal
                    required
                    v-model="itemToEdit.address.address1"
                  />
                </CCol>
                <CCol lg="6">
                  <CInput
                    label="建物・その他"
                    horizontal
                    required
                    v-model="itemToEdit.address.address2"
                  />
                </CCol>
              </CRow>
              <!-- <CRow v-if="admin"> -->
            </CForm>
          </CCardBody>

          <CCardFooter>
            <div class="footer-navigation">
              <CButton
                @click="confirmModal = true"
                color="success"
                class="ml-0 px-5"
                :disabled="$v.itemToEdit.$invalid"
                ><i class="icon cil-save"></i> 保存</CButton
              >
            </div>

            <!-- <CButton @click="goBack()" color="dark" class="ml-5 px-4">
              <b>←</b>戻る
            </CButton>-->
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol lg="3">
                <h3 class="card-title">家族情報</h3>
              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol lg="2">
                <CButton @click="onFamilyAddClick()" color="info" class="mb-3"
                  ><i class="icon cil-user-follow"></i> 家族登録</CButton
                >
              </CCol>
            </CRow>
            <CRow>
              <CCol
                lg="6"
                v-for="data in families"
                :key="data.id"
                class="float-left"
              >
                <CCard>
                  <CCardHeader>
                    <CInput
                      label="カードID"
                      horizontal
                      plaintext
                      v-model="data.relative.cardId"
                    />
                  </CCardHeader>
                  <CCardBody>
                    <CForm class="member-info edit-form">
                      <CRow>
                        <CCol lg="12">
                          <CInput
                            label="氏"
                            horizontal
                            plaintext
                            v-model="data.relative.familyName"
                          />
                        </CCol>
                        <CCol lg="12">
                          <CInput
                            label="氏（カナ）"
                            horizontal
                            plaintext
                            v-model="data.relative.firstName"
                          />
                        </CCol>
                        <CCol lg="12">
                          <CInput
                            label="名"
                            horizontal
                            plaintext
                            v-model="data.relative.givenName"
                          />
                        </CCol>

                        <CCol lg="12">
                          <CInput
                            label="名（カナ）"
                            horizontal
                            plaintext
                            v-model="data.relative.lastName"
                          />
                        </CCol>
                        <CCol lg="12">
                          <CSelect
                            label="性別"
                            horizontal
                            disabled
                            :options="options.genderOptions"
                            v-model="data.relative.gender"
                          />
                        </CCol>
                        <CCol lg="12">
                          <!-- <CInput
                            label="生年月日"
                            horizontal
                            plaintext
                            v-model="data.relative.birth"
                          /> -->
                          <div class="form-group form-row">
                            <label class="col-form-label col-sm-3"
                              >生年月日</label
                            >
                            <div class="col-sm-9">
                              <span>{{
                                data.relative.birth | formatDate
                              }}</span>
                            </div>
                          </div>
                        </CCol>
                        <CCol lg="12">
                          <CSelect
                            label="関係"
                            horizontal
                            disabled
                            :options="options.relationOptions"
                            :value.sync="data.description"
                          />
                          <!-- v-model="data.name" /> -->
                        </CCol>
                      </CRow>
                    </CForm>
                  </CCardBody>
                  <CCardFooter>
                    <CButton @click="onFamilyEditClick(data.id)" color="info"
                      ><i class="icon cil-pencil"></i> 編集</CButton
                    >
                  </CCardFooter>
                </CCard>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol>
                <h3 class="card-title">退会オペレーシ</h3>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol>
                <CButton @click="openwithdrawalModal()" color="danger"
                  ><i class="icon cil-user-follow"></i> 退会させる</CButton
                >
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>

      <CModal
        color="dark"
        :closeOnBackdrop="false"
        :centered="true"
        :show.sync="addFamilyModal"
      >
        <CRow>
          <!-- <CCol lg="12">
            <CInput label="氏" horizontal v-model="familyAdd.familyName" />
          </CCol>
          <CCol lg="12">
            <CInput label="名" horizontal v-model="familyAdd.givenName" />
          </CCol>
          <CCol lg="12">
            <CInput
              label="氏（カナ）"
              horizontal
              v-model="familyAdd.lastName"
            />

          </CCol>
          <CCol lg="12">
            <CInput
              label="名（カナ）"
              horizontal
              v-model="familyAdd.firstName"
            />
          </CCol> -->
          <CCol lg="12">
            <div class="form-group form-row">
              <label class="col-form-label col-sm-3">氏</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  v-model="familyAdd.familyName"
                  v-on:input="familyName_furigana"
                />
              </div>
            </div>
          </CCol>

          <CCol lg="12">
            <CInput
              label="氏（カナ）"
              horizontal
              v-model="familyAdd.firstName"
            />
          </CCol>

          <CCol lg="12">
            <div class="form-group form-row">
              <label class="col-form-label col-sm-3">名</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  v-model="familyAdd.givenName"
                  v-on:input="givenName_furigana"
                />
              </div>
            </div>
          </CCol>
          <CCol lg="12">
            <CInput
              label="名（カナ）"
              horizontal
              v-model="familyAdd.lastName"
            />
          </CCol>

          <CCol lg="12">
            <CSelect
              label="性別"
              horizontal
              :options="options.genderOptions"
              :value.sync="familyAdd.gender"
            />
          </CCol>
          <CCol lg="12">
            <CInput
              label="生年月日"
              type="date"
              horizontal
              v-model="familyAdd.birth"
            />
            <!-- <div
              class="text-danger input-info"
              v-if="!$v.familyAdd.birth.required"
            >
              生年月日の入力は必須です
            </div> -->
          </CCol>
          <CCol lg="12">
            <CSelect
              label="関係"
              horizontal
              :options="options.relationOptions"
              :value.sync="familyAdd.relation"
            />
            <!-- <div
              class="text-danger input-info"
              v-if="!$v.familyAdd.relation.required"
            >
              関係の入力は必須です
            </div> -->
          </CCol>
        </CRow>
        <template #header> 家族登録 </template>
        <template #footer>
          <CButton
            @click="addFamilyModal = false"
            color="secondary"
            class="float-left"
          >
            <i class="icon cil-x"></i> キャンセル
          </CButton>
          <CButton @click="onFamilyAddRunClick()" color="success">
            <i class="icon cil-save"></i> 登録
          </CButton>
          <!-- <CButton
            @click="onFamilyAddRunClick()"
            color="success"
            :disabled="$v.familyAdd.$invalid"
          >
            <i class="icon cil-save"></i> 登録
          </CButton> -->
        </template>
      </CModal>

      <CModal
        color="dark"
        :closeOnBackdrop="false"
        :centered="true"
        :show.sync="editFamilyModal"
      >
        <CRow>
          <!-- <CCol lg="12">
            <CInput label="氏" horizontal v-model="familyEdit.familyName" />
          </CCol>
          <CCol lg="12">
            <CInput label="名" horizontal v-model="familyEdit.givenName" />
          </CCol>
          <CCol lg="12">
            <CInput
              label="氏（カナ）"
              horizontal
              v-model="familyEdit.lastName"
            />
          </CCol>
          <CCol lg="12">
            <CInput
              label="名（カナ）"
              horizontal
              v-model="familyEdit.firstName"
            />
          </CCol> -->
          <CCol lg="12">
            <div class="form-group form-row">
              <label class="col-form-label col-sm-3">氏</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  v-model="familyEdit.familyName"
                  v-on:input="familyName_furigana"
                />
              </div>
            </div>
          </CCol>

          <CCol lg="12">
            <CInput
              label="氏（カナ）"
              horizontal
              v-model="familyEdit.firstName"
            />
          </CCol>

          <CCol lg="12">
            <div class="form-group form-row">
              <label class="col-form-label col-sm-3">名</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  v-model="familyEdit.givenName"
                  v-on:input="givenName_furigana"
                />
              </div>
            </div>
          </CCol>
          <CCol lg="12">
            <CInput
              label="名（カナ）"
              horizontal
              v-model="familyEdit.lastName"
            />
          </CCol>
          <CCol lg="12">
            <CSelect
              label="性別"
              horizontal
              required
              :options="options.genderOptions"
              :value.sync="familyEdit.gender"
            />
          </CCol>
          <CCol lg="12">
            <CInput
              label="生年月日"
              type="date"
              horizontal
              required
              v-model="familyEdit.birth"
            />
          </CCol>
          <CCol lg="12">
            <CSelect
              label="関係"
              horizontal
              required
              :options="options.relationOptions"
              :value.sync="familyEdit.relation"
            />
          </CCol>
        </CRow>
        <template #header> 家族編集 </template>
        <template #footer>
          <CButton
            @click="editFamilyModal = false"
            color="secondary"
            class="float-left"
          >
            <i class="icon cil-x"></i> キャンセル
          </CButton>
          <CButton @click="onFamilySaveRunClick()" color="success">
            <i class="icon cil-save"></i> 保存
          </CButton>
          <CButton @click="onFamilyDeleteClick()" color="danger">
            <i class="icon cil-trash"></i> 削除
          </CButton>
        </template>
      </CModal>

      <CModal
        color="success"
        closeOnBackdrop
        :centered="true"
        :show.sync="completedModal"
      >
        更新が完了しました。
        <template #header> 更新完了 </template>
        <template #footer>
          <CButton @click="completedModal = false" color="success"
            ><i class="icon cil-x"></i> 閉じる</CButton
          >
        </template>
      </CModal>

      <CModal
        color="warning"
        closeOnBackdrop
        :centered="true"
        :show.sync="deleteConfirmModal"
      >
        削除してよろしいですか？
        <template #header> 削除確認 </template>
        <template #footer>
          <CButton
            @click="deleteConfirmModal = false"
            color="secondary"
            class="float-left"
          >
            <i class="icon cil-x"></i> キャンセル
          </CButton>
          <CButton @click="onFamilyDeleteRunClick()" color="danger">
            <i class="icon cil-trash"></i> 実行
          </CButton>
        </template>
      </CModal>

      <CModal
        color="success"
        closeOnBackdrop
        :centered="true"
        :show.sync="deleteCompleteModal"
      >
        削除が完了しました。
        <template #header> 削除完了 </template>
        <template #footer>
          <CButton @click="deleteCompleteModal = false" color="success"
            ><i class="icon cil-x"></i> 閉じる</CButton
          >
        </template>
      </CModal>
    </CRow>

    <CButton
      @click="hasHistory() ? $router.go(-1) : $router.push('/')"
      class="my-5 btn btn-dark px-5"
    >
      <i class="icon cil-arrow-left"></i> 戻る
    </CButton>

    <CModal
      color="warning"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="confirmModal"
    >
      更新してよろしいですか？
      <template #header> 更新確認 </template>
      <template #footer>
        <CButton
          @click="confirmModal = false"
          color="secondary"
          class="float-left"
          ><i class="icon cil-x"></i> キャンセル</CButton
        >
        <CButton @click="saveProfile()" color="success"
          ><i class="icon cil-pencil"></i> 更新</CButton
        >
      </template>
    </CModal>

    <CModal
      color="dark"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="cardIdEditModal"
    >
      <template #header> カードID編集 </template>
      <CInput
        label="現在のカードID"
        horizontal
        plaintext
        v-model="currentItems.cardId"
      />
      <CInput
        label="新カードID"
        class="required-mark"
        horizontal
        required
        v-model="newCardId"
      />
      <div class="text-danger input-info" v-if="!$v.newCardId.required">
        新カードIDの入力は必須です
      </div>
      <div class="text-danger input-info" v-if="!$v.newCardId.numeric">
        新カードIDは数値を入力してください
      </div>
      <div class="text-danger input-info" v-if="!$v.newCardId.maxLength">
        新カードIDは{{ valid.cardId.length }}桁の数値を入力してください
      </div>
      <div class="text-danger input-info" v-if="!$v.newCardId.minLength">
        新カードIDは{{ valid.cardId.length }}桁の数値を入力してください
      </div>
      <template #footer>
        <CButton
          @click="cardIdEditModal = false"
          color="secondary"
          class="float-left"
        >
          <i class="icon cil-x"></i> キャンセル
        </CButton>
        <CButton
          @click="onCardIdSaveClick()"
          color="success"
          :disabled="$v.newCardId.invalid"
        >
          <i class="icon cil-save"></i> 保存
        </CButton>
      </template>
    </CModal>

    <CModal
      color="success"
      closeOnBackdrop
      :centered="true"
      :show.sync="completedModal"
    >
      <template #header>
        <h4>更新完了</h4>
      </template>
      更新が完了しました。
      <template #footer>
        <CButton @click="completedModal = false" color="success"
          ><i class="icon cil-x"></i> 閉じる</CButton
        >
      </template>
    </CModal>

    <!-- 退会手続きモーダル -->
    <CModal
      :show.sync="withdrawalModal"
      :closeOnBackdrop="false"
      :centered="true"
      size="xl"
      color="dark"
    >
      <template #header>
        <h5>退会オペレーシ</h5>
      </template>
      <CForm class="modal-form p-4">
        <CRow>
          <CCol lg="12" class="px-0 mb-3">
            <h4 class="sub-title">ご利用規約</h4>
          </CCol>
        </CRow>
        <CRow>
          <CCol class="overflow-section border p-1 mb-2">
            <div class="terms_and_condition">
              <strong>【ご利用規約】</strong>
              <p>
                本規約は、株式会社リバティー（以下「弊社」といいます）の運営する施設およびWEBサイト（以下「本サービス」という）の利用条件について定めるものです。
              </p>

              <strong>第1条(会員資格)</strong>
              <p>
                入会は以下の規約に同意いただき、所定の会員登録手続きを完了された方といたします。
              </p>

              <strong>第2条(基本合意)</strong>
              <p>
                本サービスの利用については会員の責任となります。また、会員は本規約を承諾したうえで本サービスを利用するものとします。弊社が本サービス通じて随時会員に向けて発表する諸規定は、本規約の一部を構成し、会員はこれを承諾したうえで本サービスを利用するものとします。この規約は任意に変更することがあり、変更後に本サービスの利用があった場合には、会員はこの変更を承諾したものとします。<br />
              </p>

              <strong>第3条(会員)</strong>
              <p>
                1.弊社所定の登録手続きから氏名・生年月日・電話番号・メールアドレス・会員が任意に設定するパスワードなど(以下「会員情報」といいます)を弊社の定める方法に従って登録された方を会員とします。<br />
                2.会員は、登録した会員情報が真実であることを保証するものとし、弊社は、会員情報に基づいてのみ本サービスの利用を承諾するものとします。<br />
                3.次に該当する場合は、会員となることはできず、会員登録終了後においても、弊社の判断で会員資格を喪失することがあります。<br />
                (1)会員が実在しない場合<br />
                (2)過去に本規約違反などにより、会員資格の停止又は取消しが行われている場合<br />
                (3)会員情報に、虚偽の記載、誤記、又は記入漏れがあった場合<br />
                (4)弊社の業務の遂行上又は技術上支障がある場合<br />
                (5)会員が本規約に違反した場合<br />
                (6)その他、弊社が会員であることを不適当と判断した場合<br />
                4.弊社が会員に連絡、通知する場合、会員情報に登録された電話番号への連絡、メールアドレスへの送信をもって到達したものとみなします。
              </p>

              <strong>第4条(個人情報の利用目的)</strong>
              <p>
                ご登録頂いた個人情報は弊社内で共有し、ご挨拶や弊社提供の特典情報および宿泊プラン、通信販売等の新商品のご案内や、各種関連商品の販売、勧誘、広告及び宣伝物の送付、送信（電子メールを含む。）、ご案内、弊社内部における市場調査及び分析並びに商品及びアフターサービスの研究、開発及び実施のために利用いたします。
              </p>

              <strong>第5条(会員情報の取扱い)</strong>
              <p>
                1.本条にいう会員情報とは、ご登録いただいた個人情報、会員もしくは会員の代表者個人に関する氏名（フリガナを含む）、住所、電話番号、生年月日、ご職業、メールアドレス、クレジットカード情報、取引履歴、弊社に対して発生する料金の支払状況、その他届け出た情報とします。<br />
                2.本規約による義務の履行または権利行使のために、弊社は会員情報を保存し管理するものとします。<br />
                3.弊社は、本条第2項及び以下の各号に定める場合を除いて、第三者に対し会員情報の開示を行わないものとします。<br />
                (1)会員が同意する場合<br />
                (2)弊社が実施する懸賞に当選した会員に関して、当選者の氏名及び住所の存する都道府県名を公表する場合<br />
                (3)法令により開示が求められた場合<br />
                (4)本サイト上での会員の行為が、法令または利用規約等に反し、弊社の権利、財産が侵害されるおそれがある場合や、本サービスの提供に支障があると認められる場合<br />
                (5)裁判所、検察官、警察、弁護士会、消費者センターまたはこれに準じた権限を有する機関から、会員の登録内容についての開示が求められた場合<br />
                4.弊社は、会員情報の管理には最大限の努力を払いますが、万が一、第三者による故意のハッキング等により生じた情報漏洩やこれに伴い会員に生じた損害すべてに対し、いかなる責任も負わないものとします。
              </p>

              <strong>第6条(会員情報の開示・訂正・削除等)</strong>
              <p>
                弊社の定める方法に従い、会員から会員情報の利用目的の通知、開示、訂正、利用停止等の請求がある場合、弊社は請求があった会員本人もしくは会員の代表者に関するこれらの開示、修正等を行うものとします。なお、開示、訂正等の請求は以下に連絡するものとします。<br />
                連絡先メールアドレス：ask@liberty-resort.jp
              </p>

              <strong>第7条(設備等)</strong>
              <p>
                会員は、本サービスを利用するために必要な通信機器、その他の機器を自己の負担において、準備するものとします。また、自己費用で電気通信サービスを利用してサーバーへ接続するものとします。必要な手続きは会員が自己の責任と費用で行なうものとします。
              </p>

              <strong>第8条(禁止事項)</strong>
              <p>
                1.本サービスの利用に際し、会員は次号に該当する行為を行うことはできません。<br />
                (1)法令又は本規約、公序良俗に反する行為<br />
                (2)第三者の権利、利益を侵害する行為又は第三者の迷惑になる行為<br />
                (3)未成年者に対し悪影響があると判断される行為<br />
                (4)本サービスの運営を妨げ、又は、本サイトもしくは弊社の信用を毀損する行為<br />
                (5)本サービスを通じて入手した情報を私的使用目的以外の方法で利用し、又は第三者に同様の行為をさせる行為（但し、弊社が承認した場合は除く）<br />
                2.会員の行為が前項に該当すると弊社が判断した場合、弊社は会員に対し当該行為の停止を求めることができるほか、会員資格の喪失を決定することができるものとします。
              </p>

              <strong>第9条(会員間の情報)</strong>
              <p>
                1.会員は、自己の責任と良識に従って本サービスを利用するものとし、利用に際して、弊社、第三者に迷惑をかけないものとします。<br />
                2.会員同士でなされた情報の授受、およびそれに付随して行われる行為について弊社は一切責任を負わないものとします。<br />
                3.会員同士あるいは弊社と会員とでなされた情報の授受に関して、当該情報が各種WEB上のウィルス等に感染していたことにより弊社やその他の第三者が損害を蒙った場合、当該情報を掲載した会員はその損害を賠償するものとします。また、本サービスは当該損害について会員または第三者について一切責任を負わないものとします。
              </p>

              <strong>第10条(権利の帰属)</strong>
              <p>
                本サービスを通じて会員から提供された情報や作品その他のコンテンツに関する知的財産権（著作権その他のノウハウ等）は、すべて弊社に帰属するものとします。
              </p>

              <strong>第11条(本サービスの内容の変更および停止)</strong>
              <p>
                弊社は予告なく本サービスの内容の変更、利用停止または中止をすることができるものとします。この変更、停止、中止などについては、本サービスを通じて発表するものとします。この場合に会員または第三者に生じた損害については、弊社はいかなる責任も負わないものとします。
              </p>

              <strong>第12条(一時的な中断)</strong>
              <p>
                弊社は、以下の各号に該当する場合には事前に連絡することなく本サービスを一時的に中断することができるものとします。<br />
                (1)本サイトのシステムの保守、点検、修理、変更を定期的にまたは緊急に行なう場合<br />
                (2)火災、停電などにより提供ができなくなった場合<br />
                (3)地震、噴火、洪水、津波などの天災により提供ができなくなった場合<br />
                (4)戦争、変乱、暴動、騒乱、労働争議などにより提供ができなくなった場合<br />
                (5)その他、運用上、技術上本サービスが一時的な中断を必要と判断した場合
              </p>

              <strong>第13条(本サービスの内容の保証および中断)</strong>
              <p>
                弊社は、本サイトに関して提供する情報、会員が登録する情報について、そのいかなる保証も行ないません。弊社は、理由の如何を問わず、本サイトの提供の遅延または中断などが発生し、その結果会員または他の第三者が損害を被ったとしても当該損害について一切の責任を負わないものとします。
              </p>

              <strong>第14条(損害賠償)</strong>
              <p>
                1.本サービスの利用により発生した会員の損害すべてに対し、弊社はいかなる責任も負わないものとします。損害には第三者による故意のハッキング等により生じた情報漏洩を含みます。また、弊社が会員の登録、掲載した情報を削除し、会員資格を停止し、抹消し、本サービスを停止、中断、中止したことにつき、弊社は事由の如何を問わず、いかなる責任も負わないものとします。<br />
                2.会員が本サービスの利用によって他の会員や第三者に対して損害を与えた場合、会員は自己の責任と費用をもって解決し、弊社に損害を与えることのないものとします。
              </p>

              <strong>第15条(専属的合意管轄裁判所)</strong>
              <p>
                会員と弊社との間で訴訟の必要が生じた場合、静岡地方裁判所もしくは静岡簡易裁判所を専属的合意管轄裁判所とします。
              </p>

              <p>令和2年10月23日制定</p>
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <!-- <div class="checkbok_overlay">
              <div>
                <CInputCheckbox :checked.sync="withdrawalAgree" />
              </div>
              <label>アカウントが削除され、ログインできなくなることに同意する。</label>
              <p>（同意にチェック後、「退会する」ボタンが表示されます。）</p>
            </div> -->
            <label class="check-inline">
              <input type="checkbox" v-model="withdrawalAgree" />
              <span
                >お客様は利用規約に同意した上で退会することを確認した。</span
              >
            </label>
            <p>（確認にチェック後、「退会」ボタンが表示されます。）</p>
          </CCol>

          <!-- <CCol> -->
          <!-- <div>
              <input type="checkbox" v-model="withdrawalAgree" />
              <label for="checkbox"
                >アカウントが削除され、ログインできなくなることに同意する。</label
              >
              <p>※同意にチェックを入れると「退会する」ボタンが表示されます。</p>
            </div> -->
          <!-- </CCol> -->
        </CRow>
      </CForm>
      <template #footer>
        <CButton @click="closeWithdrawalModal()" color="secondary"
          ><i class="icon cil-x"></i> 閉じる</CButton
        >
        <CButton
          v-if="withdrawalAgree"
          @click="withdrawalConfirmModal = true"
          color="danger"
          ><i class="icon cil-save"></i> 退会させる</CButton
        >
      </template>
    </CModal>

    <!-- 退会手続き最終確認 -->
    <CModal
      color="warning"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="withdrawalConfirmModal"
      size="l"
    >
      <p>退会させてよろしいですか？</p>
      <template #header>
        <h4>退会オペレーシの最終確認</h4>
      </template>
      <template #footer>
        <CButton
          @click="closeWithdrawalConfirmModal()"
          color="secondary"
          class="float-left"
          ><i class="icon cil-x"></i> キャンセル</CButton
        >
        <CButton @click="withdrawalProfileRun()" color="danger"
          ><i class="icon cil-pencil"></i> 退会させる</CButton
        >
      </template>
    </CModal>
     
  </div>
</template>

<script>
// import Vue from 'vue'
import axios from "axios";
import {
  required,
  numeric,
  minLength,
  maxLength,
  helpers,
} from "vuelidate/lib/validators";
import Options from "../components/Options";
import historykana from "historykana";
import * as wanakana from "wanakana";

const CARD_ID = { LENGTH: 16 };
const ZIPCODE_URL =
  "https://jxamy7mdqg.execute-api.ap-northeast-1.amazonaws.com/api/";
const alphaEmailValidator = helpers.regex(
  "alphaEmail",
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

export default {
  components: {
    // FamilyMember
  },
  name: "ProfileEdit",
  data() {
    return {
       
      confirmModal: false,
      addFamilyModal: false,
      editFamilyModal: false,
      deleteConfirmModal: false,
      deleteCompleteModal: false,
      completedModal: false,
      cardIdEditModal: false,
      newMember: false,
      addEmailModal: false,
      showEmail: false,
      withdrawalModal: false,
      withdrawalAgree: false,
      withdrawalConfirmModal: false,
      withdrawalCompleteModal: false,
      loadData: false,
      gUserName: "",
      Gemail: "",
      history: [],
      allGroups: [],
      UserGroups: [],
      userGroupName: "",
      UserGroup: "",
      admin: false,

      tableItems: [],
      copyItems: [],
      families: [],
      familyAdd: {},
      familyEdit: {},
      relationId: "",
      addEmail: "",
      // fullName: "",
      // gUserName: "",

      codeOptions: [],
      countryOptions: [],
      userGroupsOptions: [
        { value: "", label: "" },
        { value: "", label: "" },
        { value: "", label: "" },
      ],
      options: Options.data(),
      currentItems: {},
      itemToEdit: {
        firstName: "",
        lastName: "",
        familyName: "",
        givenName: "",
        gender: "",
        birth: "",
        userName: "",
        cardId: "",
        email: "",
        emailVerified: true,
        countryCode: "",
        mobile: "",
        address: {
          address1: "",
          address2: "",
          city: "",
          state: "",
          zipCode: "",
          country: {
            name: "",
          },
        },
      },
      userGroupEdit: {
        userGroupSelected: "",
      },
      newCardId: "",
      valid: {
        cardId: { length: CARD_ID.LENGTH },
      },
    };
  },

  created() {
    this.gUserName = this.$route.params.userId;
    if (this.$route.params.success) {
      this.newMember = true;
      setTimeout(() => (this.newMember = false), 2000);
    }
  },

  validations: {
    itemToEdit: {
      firstName: { required },
      lastName: { required },
      familyName: { required },
      givenName: { required },
    },
    newCardId: {
      required,
      numeric,
      minLength: minLength(CARD_ID.LENGTH),
      maxLength: maxLength(CARD_ID.LENGTH),
    },
    addEmail: {
      required,
      alphaEmailValidator,
    },
  },

  filters: {
    genderString: function (value) {
      if (!value) return "公開しない";
      var retString;
      switch (value) {
        case "UNKONWN":
          retString = "公開しない";
          break;
        case "MALE":
          retString = "男性";
          break;
        case "FEMALE":
          retString = "女性";
          break;
        default:
          retString = "未知";
          break;
      }
      return retString;
    },
  },

  methods: {
    getUserInformation: function () {
      //Login as registered user
      var urlRequest = "/rest/users/" + this.gUserName;
      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.loadData = true;
          this.itemToEdit = resp.data;
          this.currentItems = this.itemToEdit;
          this.Gemail = this.currentItems.email;
          // this.currentCardId = this.itemToEdit.cardId;
        })
        .catch((err) => {
           
          console.log(err);
        });
    },
    // put profiel update
    saveProfile: function () {
      var urlRequest;
      urlRequest = "/rest/users/" + this.gUserName;
      console.log(this.itemToEdit);
      axios
        .put(urlRequest, this.itemToEdit, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("User profile updated:" + resp.data);
          this.getUserInformation();
          this.confirmModal = false;
          this.completedModal = true;
        })
        .catch((err) => {
           

          console.log("Updating profile error: " + err);
          this.errors = err;
        });

      //user group update
      var groupRequest = {
        groups: [this.userGroupName],
      };

      var urlRequestG = "/rest/users/" + this.gUserName + "/groups";

      axios
        .put(urlRequestG, groupRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log(resp.data);
        })
        .catch((err) => {
           

          console.log(err);
          this.errors = err;
        });
    },

    getAllGroup: function () {
      //Get all user groups
      var urlRequest = "/rest/groups";

      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.allGroups = resp.data;
          this.userSelectionRole();
          console.log("User Data:" + JSON.stringify(this.allGroups));
        })
        .catch((err) => {
           

          console.log(err);
          this.searchResult = "会員が見つかりませんでした。";
        });
    },
    // add email address to CardId
    saveEmail: function () {
      var urlRequest;
      urlRequest = "/rest/users/" + this.gUserName + "/email";

      var userInfoE = {
        username: this.gUserName,
        email: this.addEmail,
      };

      axios
        .put(urlRequest, userInfoE, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("User profile updated:" + resp.data);
          this.getUserInformation();
          this.Gemail = this.addEmail;
          this.itemToEdit.email = this.addEmail;
          this.addEmailModal = false;
          this.completedModal = true;
        })
        .catch((err) => {
           

          console.log("Updating profile error: " + err);
          this.errors = err;
        });
    },
    // create a array data for groups option
    userSelectionRole: function () {
      this.userGroupsOptions = [];
      for (let i = 0; i < this.allGroups.length; i++) {
        let cId = this.allGroups[i].id;
        let cName = this.allGroups[i].name;
        this.userGroupsOptions.push({ value: cId, label: cName });
      }
      return this.userGroupsOptions;
    },
    // get appointed group
    getUserGroup: function () {
      var urlRequest = "/rest/users/" + this.gUserName + "/groups";

      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.UserGroups = resp.data;
          this.userGroupName = this.UserGroups[0].id;
          this.UserGroups[0].name == "liberty operator admin"
            ? (this.admin = true)
            : false;

          console.log("User group Data:" + JSON.stringify(this.UserGroups));
        })
        .catch((err) => {
           

          console.log(err);
          this.searchResult = "会員が見つかりませんでした。";
        });
    },
    hasHistory() {
      return window.history.length > 2;
    },

    getCountries: function () {
      //Login as registered user
      var urlRequest = "/rest/country";
      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          // console.log("getCountries:" + JSON.stringify(resp.data));

          this.countryOptions = [];
          this.codeOptions = [];
          resp.data.forEach((element) => {
            this.countryOptions.push({
              value: element.id,
              label: element.name,
            });
            // 国際電話の国番号をセット
            this.codeOptions.push({
              value: element.dial,
              label: element.name + " (" + element.dial + ")",
            });
          });
        })
        .catch((err) => {
           
          console.log(err);
        });
    },

    //#region    ===== function =====

    /**
     * カードID保存
     */
    saveCardId: function () {
      const urlRequest = "/rest/users/" + this.gUserName;
      console.log(this.currentItems);

      // NOTE: 会員情報編集前の値を使用して、カードIDのみ更新する
      let body = this.currentItems;
      body.cardId = this.newCardId;

      axios
        .put(urlRequest, body, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Card Id saved:" + resp.data);
          this.getUserInformation();
          this.cardIdEditModal = false;
          this.completedModal = true;
        })
        .catch((err) => {
           
          console.log("Updating profile error: " + err);
          this.errors = err;
        });
    },

    //#endregion ===== function =====

    //#region    ===== event =====

    /**
     * カードID編集ダイアログ
     */
    onCardIdEditClick() {
      // this.newCardId = "";
      // this.cardIdEditModal = true;
      this.$router.push({
        name: "会員証発行",
        params: { userId: this.itemToEdit.name },
      });
    },

    /**
     * カードIDセットボタンクリック
     */
    onCardIdSaveClick() {
      this.saveCardId();
    },

    /**
     * 住所自動入力ボタンクリック
     */
    onInputAddressClick() {
      this.getAddress();
    },

    /**
     * 住所取得
     */
    getAddress: function () {
      // Get address by zipcode
      const urlRequest =
        ZIPCODE_URL + "?postcode=" + this.itemToEdit.address.zipCode;

      axios
        .get(urlRequest)
        .then((resp) => {
          console.log("resp.data: ", resp.data);
          this.itemToEdit.address.state = resp.data.PrefecturesName;
          this.itemToEdit.address.city =
            resp.data.CityName + resp.data.TownName;
        })
        .catch((err) => {
           
          console.log(err);
        });
    },

    /**
     * Eメールアドレス承認状態
     */
    emailVerifiedString: function (value) {
      if (!value) return "不明";
      switch (value) {
        case true:
          return "承認済み";
        case false:
          return "未承認";
        default:
          return "不明";
      }
    },

    //#endregion ===== event =====

    //#region FamilyMember !!HACK!!

    /**
     * 家族会員登録の実装
     */
    addFamily() {
      var urlRequest = "/rest/users/" + this.gUserName + "/relative";

      console.log(this.familyAdd);
      axios
        .post(urlRequest, this.familyAdd, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Family added:" + JSON.stringify(resp.data));
          this.getFamilies();
        })
        .catch((err) => {
           
          console.log("Family added error: " + err);
          this.errors = err;
        });
    },

    /**
     * 全家族会員の取得
     */
    getFamilies() {
      var urlRequest = "/rest/users/" + this.gUserName + "/relative";

      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Families get: ");
          console.log(resp.data);
          this.families = [];
          this.families = resp.data;
        })
        .catch((err) => {
           
          console.log("Families get error: " + err);
          this.errors = err;
        });
    },

    /**
     * 家族1人更新リクエスト
     */
    putFamily() {
      // NOTE: 会員更新同様の処理を行う
      var urlRequest = "/rest/users/" + this.familyEdit.userName;

      console.log(this.familyEdit);
      axios
        .put(urlRequest, this.familyEdit, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Family put:" + JSON.stringify(resp.data));
          // NOTE: 会員更新は関係がないため、別途関係更新リクエストが必要
          this.putRelation();
        })
        .catch((err) => {
           
          console.log("Family put error: " + err);
          this.errors = err;
        });
    },

    /**
     * 関係更新リクエスト
     */
    putRelation() {
      // NOTE: 会員と家族の関係更新のみの処理を行う
      var urlRequest =
        "/rest/users/" + this.gUserName + "/relative/" + this.relationId;

      const body = {
        name: this.familyEdit.relation,
        description: this.familyEdit.relation,
      };

      console.log(body);
      axios
        .put(urlRequest, body, {
          // .put(urlRequest, this.familyEdit, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Relation put:" + JSON.stringify(resp.data));
          this.getFamilies();
        })
        .catch((err) => {
           
          console.log("Family put error: " + err);
          this.errors = err;
        });
    },

    /**
     * 家族1人削除リクエスト
     */
    deleteFamily() {
      var urlRequest =
        "/rest/users/" + this.gUserName + "/relative/" + this.relationId;

      axios
        .delete(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Family deleted:" + JSON.stringify(resp.data));
          this.getFamilies();
        })
        .catch((err) => {
           
          console.log("Family delete error: " + err);
          this.errors = err;
        });
    },

    /**
     * 家族登録ボタンクリック
     */
    onFamilyAddClick() {
      // 家族登録ダイアログのデータを初期化
      {
        this.familyAdd.givenName = "";
        this.familyAdd.familyName = "";
        this.familyAdd.lastName = "";
        this.familyAdd.firstName = "";
        this.familyAdd.gender = "UNKNOWN";
        this.familyAdd.birth = "";
        // note: passwordはパラメータ必須。値は空でよい。
        this.familyAdd.password = "";
        this.familyAdd.relation = "OTHER";
      }

      this.addFamilyModal = true;
    },

    /**
     * 家族登録ボタンクリック
     */
    onFamilyAddRunClick() {
      this.addFamily();
      this.addFamilyModal = false;
      this.completedModal = true;
    },

    /**
     * 家族編集ボタンクリック
     */
    onFamilyEditClick(id) {
      this.relationId = id;
      const editData = this.families.filter((a) => a.id == id)[0];

      // 家族編集ダイアログのデータを初期化
      {
        this.familyEdit.givenName = editData.relative.givenName || "";
        this.familyEdit.familyName = editData.relative.familyName || "";
        this.familyEdit.lastName = editData.relative.lastName || "";
        this.familyEdit.firstName = editData.relative.firstName || "";
        this.familyEdit.gender = editData.relative.gender || "UNKNOWN";
        this.familyEdit.birth = editData.relative.birth || "";
        // note: passwordはパラメータ必須。値は空でよい。
        this.familyEdit.password = "";
        this.familyEdit.relation = editData.description || "OTHER";
        // this.familyEdit.relationName = editData.name || "OTHER";
        this.familyEdit.userName = editData.relative.name || "";
        this.familyEdit.cardId = editData.relative.cardId || "";
        this.familyEdit.id = editData.relative.id || "";
        this.familyEdit.name = editData.relative.name || "";
        this.familyEdit.status = editData.relative.status || "";
      }

      this.editFamilyModal = true;
    },

    /**
     * 家族保存ボタンクリック
     */
    onFamilySaveRunClick() {
      this.putFamily();
      this.editFamilyModal = false;
      this.completedModal = true;
    },

    /**
     * 家族削除ボタンクリック
     */
    onFamilyDeleteClick() {
      this.deleteConfirmModal = true;
    },

    /**
     * 家族削除実行ボタンクリック
     */
    onFamilyDeleteRunClick() {
      this.deleteFamily();
      this.editFamilyModal = false;
      this.deleteConfirmModal = false;
      this.deleteCompleteModal = true;
    },

    /**
     * 家族カードID編集ボタンクリック
     */
    onFamilyCardIdEditClick(id) {
      this.relationId = id;
      const editData = this.families.filter((a) => a.id == id)[0];

      // 家族カードID編集ダイアログのデータを初期化
      {
        this.familyEdit.givenName = editData.relative.givenName || "";
        this.familyEdit.familyName = editData.relative.familyName || "";
        // this.familyEdit.lastName = editData.relative.lastName || "";
        // this.familyEdit.firstName = editData.relative.firstName || "";
        // this.familyEdit.gender = editData.relative.gender || "UNKNOWN";
        // this.familyEdit.birth = editData.relative.birth || "";
        // this.familyEdit.password = "";
        // this.familyEdit.relation = editData.description || "OTHER";
        // this.familyEdit.userName = editData.relative.name || "";
        this.familyEdit.cardId = editData.relative.cardId || "";
        // this.familyEdit.id = editData.relative.id || "";
        // this.familyEdit.name = editData.relative.name || "";
        // this.familyEdit.status = editData.relative.status || "";
      }

      this.editCardIdModal = true;
    },

    /**
     * 退会内容モーダル表示
     */
    openwithdrawalModal: function () {
      this.withdrawalAgree = false;
      this.withdrawalModal = true;
    },
    /**
     * 退会内容確認モーダル閉じる
     */
    closeWithdrawalModal: function () {
      this.withdrawalModal = false;
    },

    /**
     * 退会最終確認モーダル閉じる
     */
    closeWithdrawalConfirmModal: function () {
      this.withdrawalConfirmModal = false;
      this.closeWithdrawalModal();
    },

    /**
     * 退会最終確認モーダル退会押下
     */
    withdrawalProfileRun: function () {
      this.withdrawalModal = false;
      this.withdrawalConfirmModal = false;
      var urlRequest;
      urlRequest = "/rest/users/" + this.gUserName + "/status";
      axios
        .put(
          urlRequest,
          { enabled: false },
          {
            headers: { Authorization: `Bearer ${this.$keycloak.token}` },
          }
        )
        .then((resp) => {
          console.log("User profile updated:" + resp.data);
          //this.getUserInformation();
          this.$router.push("/member-search");
        })
        .catch((err) => {
           

          // this.completedModal = true;
          // this.memberFormReset();
          // this.scrollTop();
          console.log("Updating profile error: " + err);
          this.errors = err;
        });
    },
    // TODO: 仕様確認
    /**
     * 家族カードID保存ボタンクリック
     */
    onFamilyCardIdSaveRunClick() {
      this.putFamilyCardId();
      this.editCardIdModal = false;
      this.completedModal = true;
    },

    //#eneregion FamilyMember

    familyName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.itemToEdit.firstName = input.target.value;
        this.familyAdd.firstName = input.target.value;
        this.familyEdit.firstName = input.target.value;
      } else {
        this.history.push(input.target.value);
        this.itemToEdit.firstName = wanakana.toKatakana(
          historykana(this.history)
        );
        this.familyAdd.firstName = wanakana.toKatakana(
          historykana(this.history)
        );
        this.familyEdit.firstName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    givenName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.itemToEdit.lastName = input.target.value;
        this.familyAdd.lastName = input.target.value;
        this.familyEdit.lastName = input.target.value;
      } else {
        this.history.push(input.target.value);
        this.itemToEdit.lastName = wanakana.toKatakana(
          historykana(this.history)
        );
        this.familyAdd.lastName = wanakana.toKatakana(
          historykana(this.history)
        );
        this.familyEdit.lastName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
  },
  beforeMount() {
    this.getCountries();
    this.getUserInformation();
    this.getAllGroup();
    this.getUserGroup();
    this.getFamilies();
  },
  computed: {
    fullName: function () {
      return this.itemToEdit.familyName + " " + this.itemToEdit.givenName;
    },
  },
};
</script>
<style>
.expand-transition {
  transition: all 2s ease;
  height: 30px;
  padding: 10px;
}

.expand-enter,
.expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
</style>
